export const ACTIVE = 'Active';
export const NOT_ACTIVE = 'Not Active';
export const DISABLED = 'Disabled';
export const DELETED = 'Deleted';
export const FIRM_STATUSES = [ACTIVE, NOT_ACTIVE];
export const ON_HOLD = 'On Hold';

export const DEFAULT_PROFILE_PICTURE_FILE = '/images/empty-profile-picture.png';

export const STAFF_PAGE = 'Staff';
export const OFFICE_PAGE = 'Office';
export const ATTORNEY_PAGE = 'Attorney';
export const FIRM_PAGE = 'Firm';
export const NEGOTIATED_FEE_PAGE = 'Negotiated Fee';
export const PAYMENT_PAGE = 'Payment';

export const LANGUAGES = [
  'English',
  'Afrikaans',
  'Arabic',
  'Armenian',
  'Ashanti',
  'Assyrian',
  'Bosnian',
  'Bulgarian',
  'Cambodian',
  'Chinese',
  'Creole',
  'Croatian',
  'Czech',
  'Danish',
  'Dutch',
  'Farsi',
  'Filipino',
  'Flemish',
  'French',
  'German',
  'Greek',
  'Gujarati',
  'Haitian',
  'Hebrew',
  'Hindi',
  'Hungarian',
  'Igbo',
  'Ilocano',
  'Indian',
  'Italian',
  'Japanese',
  'Korean',
  'Latvian',
  'Lebanese',
  'Lithuanian',
  'Mandarin',
  'Navajo',
  'Norwegian',
  'Pakistan',
  'Polish',
  'Portuguese',
  'Punjabe',
  'Russian',
  'Serbian',
  'Sign Language',
  'Slovak',
  'Spanish',
  'Swedish',
  'Tagalog',
  'Taiwanese',
  'Turkish',
  'Ukranian',
  'Vietnamese',
  'Yiddish',
];

export const FIELD_REQUIRED_MESSAGE = 'This field is required';
export const BAR_NUMBER_REQUIRED_MESSAGE = 'At least one Bar Number required';
export const ATTORNEY_NAME_DELIMITER = '*';

export const UPDATE = 'Update';
export const REGISTER = 'Register';
export const CONFIRM = 'Confirm';
export const ADD = 'Add';

// Phone number should either be in the format (XXX) XXX-XXXX or just a 10 digit string
export const PHONE_REGEX = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]\d{4}$|^\d{10}$/;

export const ZIP_CODE_REGEX = /^\d{5}(?:[-\s]\d{4})?$/;

export const CA_ZIP_CODE_REGEX = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] ?\d[ABCEGHJ-NPRSTV-Z]\d$/;

export const OFFICE_SUBMITTED = 'SUBMITTED';
export const OFFICE_DENIED = 'DENIED';
export const OFFICE_APPROVED = 'APPROVED';

export const FIRM_INFO_TITLE = 'Firm Information';
export const FIRM_BILLING_HISTORY_TITLE = 'Billing History';
export const FIRM_CLAIMS_TITLE = 'Claims';
export const FIRM_EXTRA_FEES_TITLE = 'Extra Fees';

export const PLACE_HOLDER_FIRM = {
  id: null,
  attorneys: [],
  staff: [],
  name: '',
  phone: '',
  email: '',
  firmStatus: '',
  firmStatusReason: '',
  offices: [],
};

export const YES_NO_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const OFFICE_MAXIMUM_LABEL = 'Office Consultation';
export const TELEPHONE_EMAIL_MAXIMUM_LABEL = 'Telephone/Email Consultation';
export const SERVICE_MAXIMUM_LABEL = 'Service Maximum';

export const OFFICE_MAXIMUM_KEY = 'officeMaximum';
export const TELEPHONE_EMAIL_MAXIMUM_KEY = 'telephoneEmailMaximum';
export const SERVICE_MAXIMUM_KEY = 'serviceMaximum';

export const negotiatedFeeMaximumChoices = [
  { label: OFFICE_MAXIMUM_LABEL, value: OFFICE_MAXIMUM_KEY },
  { label: TELEPHONE_EMAIL_MAXIMUM_LABEL, value: TELEPHONE_EMAIL_MAXIMUM_KEY },
  { label: SERVICE_MAXIMUM_LABEL, value: SERVICE_MAXIMUM_KEY },
];

export const OVERPAYMENT_RECOVERIES_SUPPORT_MSG =
  'Some past claim amounts may have been adjusted per our recent discussion regarding overpayment recovery. Contact your panel representative for details.';

export const VIRTUAL_OFFICE_COMMUNICATION_OPTIONS = [
  { value: 'zoom', label: 'Zoom' },
  { value: 'teams', label: 'Microsoft Teams' },
  { value: 'meet', label: 'Google Meet' },
  { value: 'webex', label: 'Cisco Webex' },
  { value: 'other', label: 'Other' },
];

export const RADIUS_OPTIONS = [
  { value: '75', label: '75 miles' },
  { value: '100', label: '100 miles' },
  { value: '125', label: '125 miles' },
];

export const PREVIOUSLY_DELETED_OFFICE_MESSAGE =
  'A previously deleted office at this location for the current firm already exists.';
